import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import { privacyListSelector } from '../../redux/data/selectors';
import { AUTH, COMMON } from '../../constants/strings';
import TermsAndPolicies from '../common/TermsAndPolicies';
import Checkbox from '../common/Checkbox';

function TermsAndPoliciesBox({
  intl: { formatMessage },
  onChange,
  termsValue,
  privacyValue,
  termsName,
  privacyName,
  className,
  privacyByCountry,
}) {
  return (
    <div className={className}>
      <Checkbox
        checked={termsValue}
        name={termsName}
        value={termsValue}
        id={termsName}
        onChange={value =>
          onChange({
            [termsName]: value,
          })
        }
      >
        <TermsAndPolicies
          text={formatMessage(AUTH.actions.tnc.textTitle)}
          textLink={formatMessage(AUTH.actions.tnc.textLink)}
          document={privacyByCountry.terms}
        />
      </Checkbox>
      <div className="mt1">
        <Checkbox
          checked={privacyValue}
          name={privacyName}
          id={privacyName}
          value={termsValue}
          onChange={value =>
            onChange({
              [privacyName]: value,
            })
          }
        >
          <TermsAndPolicies
            text={formatMessage(AUTH.actions.tnc.textTitle)}
            textLink={formatMessage(COMMON.privacy)}
            document={privacyByCountry.privacyPolicy}
          />
        </Checkbox>
      </div>
    </div>
  );
}

TermsAndPoliciesBox.propTypes = {
  intl: PropTypes.object,
  onChange: PropTypes.func,
  termsValue: PropTypes.bool,
  privacyValue: PropTypes.bool,
  termsName: PropTypes.string,
  privacyName: PropTypes.string,
  className: PropTypes.string,
  privacyByCountry: PropTypes.object,
};

const mapStateToProps = state => ({
  privacyList: privacyListSelector(state),
});

export default compose(
  injectIntl,
  connect(mapStateToProps),
  withProps(({ privacyList }) => {
    return {
      privacyByCountry: privacyList.find(item => item.country === 'USA') || {},
    };
  }),
)(TermsAndPoliciesBox);



// WEBPACK FOOTER //
// ./src/components/TermsAndPoliciesBox/index.jsx